module.exports = __webpack_public_path__ + "img/promoters-header.76b4b6ef.png";